function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2079 6.83719C11.1319 6.66938 10.9651 6.5625 10.7813 6.5625H8.90631V0.46875C8.90631 0.21 8.69631 0 8.43756 0H6.56256C6.30381 0 6.09381 0.21 6.09381 0.46875V6.5625H4.21881C4.03506 6.5625 3.86818 6.67031 3.79224 6.83719C3.71537 7.005 3.74537 7.20094 3.86631 7.33969L7.14756 11.0897C7.23662 11.1919 7.36506 11.25 7.50006 11.25C7.63506 11.25 7.76349 11.1909 7.85256 11.0897L11.1338 7.33969C11.2557 7.20188 11.2838 7.005 11.2079 6.83719Z",
  fill: "#5FCA77"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6562 10.3125V13.125H2.34375V10.3125H0.46875V14.0625C0.46875 14.5809 0.88875 15 1.40625 15H13.5938C14.1122 15 14.5312 14.5809 14.5312 14.0625V10.3125H12.6562Z",
  fill: "#5FCA77"
});

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.06fd0fec.svg";
export { ForwardRef as ReactComponent };